@file:OptIn(ExperimentalUuidApi::class)

package todo.pages

import androidx.compose.runtime.*
import app.AppProperties
import com.bookbrief.model.Book
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.foundation.layout.*
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.style.toModifier
import kotlinx.browser.window
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Text
import kotlin.uuid.ExperimentalUuidApi

import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.graphics.Image
import kotlinx.coroutines.await
import kotlinx.serialization.json.Json

import org.jetbrains.compose.web.css.AlignItems
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.rgb
import org.jetbrains.compose.web.css.rgba
import org.jetbrains.compose.web.css.vh
import org.jetbrains.compose.web.css.vw
import org.jetbrains.compose.web.dom.Button
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Label
import org.w3c.dom.HTMLScriptElement
import org.w3c.fetch.RequestInit
import kotlin.js.json

val deviceId: String = ""
val logo = "logo.jpg"

@Page
@Composable
fun HomePage() {


    val context = rememberPageContext()
    // Get URL parameters
    val params = context.route.params

    // You can access specific parameters like this:
    val activateCode = params["activateCode"] // will return null if parameter doesn't exist
    val email = params["email"]
    val resetCode = params["resetCode"]

    console.log("activateCode: $activateCode")
    console.log("email: $email")

    loadGoogleAuthScript()

    // NEW: Provide the Google auth POST endpoint to the JS script
    LaunchedEffect(Unit) {
        // apiEndpoint is already used elsewhere in this file
        window.asDynamic().googleAuthPostUrl = apiEndpoint + "/api/google-auth"
    }

    if(!activateCode.isNullOrBlank() && !email.isNullOrBlank()) {
        activateAccount(activateCode, email, onActivateSuccess =
        {email: String, userId: String ->
            println("Account activated for email: $email, userId: $userId")
            window.localStorage.setItem("username", email)
            window.localStorage.setItem("deviceId",email)
            window.localStorage.setItem("userId",userId)
            context.router.navigateTo("/")
        }
        )
        return
    }


    var username by remember { mutableStateOf("") }
    var isLoggedIn by remember { mutableStateOf(false) }
    // NEW: controls visibility of the credentials panel (Login + Register)
    var showCredentialsLoginPanel by remember { mutableStateOf(false) }

    val storedUser = window.localStorage.getItem("username")
    isLoggedIn = !storedUser.isNullOrBlank()


    var isMobile by remember { mutableStateOf(false) }
    var showSideContent by remember { mutableStateOf(false) } // <-- NEW

    LaunchedEffect(Unit) {
        window.asDynamic().showSideContent = { show: Boolean ->
            // Update the Compose state from JS
            showSideContent = show
        }
    }

    // Set up breakpoint detection
    LaunchedEffect(Unit) {
        isMobile = window.innerWidth <= 480
        console.log("isMobile: $isMobile - innerWidth: ${window.innerWidth}")
        window.onresize = {
            console.log("resized-it:" + it)
            //invoke js function to check if it is mobile
        }
    }

    // Update isLoggedIn state based on localStorage on component mount
    LaunchedEffect(Unit) {
        val storedUser = window.localStorage.getItem("username")
        isLoggedIn = !storedUser.isNullOrBlank()
    }

    Column(
        modifier = MainContainer.toModifier()
            .width(100.percent)
            // Do not set fixed height here — allow the column to size to its children
    ) {
        // Header Box
        Box(
            Modifier
                .fillMaxWidth()
                .backgroundColor(rgb(0, 0, 0))
                .color(rgb(256, 256, 256))
                .height(if(isMobile) 5.vh else 9.vh)
                .padding(0.px)
        ) {
            Row(
                modifier = Modifier.fillMaxWidth().height(12.percent).margin(top=if(isMobile)5.percent else 2.percent),
                horizontalArrangement = Arrangement.SpaceBetween,
                verticalAlignment = Alignment.CenterVertically
            ) {
                Link("/") {
                    Image(
                        src = logo,
                        alt = "Logo",
                        modifier = Modifier.width(5.vh).height(5.vh)
                    )
                }
                Row(
                    modifier = Modifier.margin(right = 12.px),
                    horizontalArrangement = Arrangement.End,
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    if (isLoggedIn || !window.localStorage.getItem("username").isNullOrBlank()) {
                        UserOnHeader(
                            isLoggedIn = isLoggedIn,
                            onLogout = {
                                isLoggedIn = false
                                username = ""
                                context.router.navigateTo("/")
                            }
                        )
                    }
                    Link("https://play.google.com/store/apps/details?id=com.bookbrief") {
                        Image(
                            src = "images/google_play.png",
                            alt = "Get it on Google Play",
                            modifier = Modifier
//                                .width(if (isMobile) 4.vh else 5.vh)
                                .height(if (isMobile) 5.vh else 6.vh)
                                .margin(left = 24.px)
                        )
                    }
                }
            }
        }

        // Main content area - This should take remaining space without scrolling
        Box(Modifier.fillMaxWidth()) {
            Row(
                Modifier
                    .fillMaxWidth()
                    .padding(top = 0.px, bottom = 0.px)
                    .gap(8.px)
                    .alignItems(AlignItems.Start)
                    .styleModifier {
                        // allow children to wrap to new rows so the main column can occupy full width
                        property("flex-wrap", "wrap")
                    }
            ) {

                // Main Content
                Column(
                    Modifier
                        .backgroundColor(rgb(255, 255, 255))
                        .padding(0.px)
                        // Make this column occupy the whole window width (flex-basis: 100%)
                        .styleModifier {
                            property("flex", "1 1 100%")
                            property("flex-basis", "100%")
                            property("min-width", "0") // prevents overflow inside flex
                            property("width", "100%")
                            property("max-width", "100%")
                        }
                         .borderRadius(8.px)
                         .boxShadow(offsetX = 0.px, offsetY = 2.px, blurRadius = 4.px, color = rgba(0,0,0,0.1))
                ) {

                    Row(
                        modifier = Modifier.fillMaxWidth().gap(8.px).width(100.percent).alignItems(AlignItems.Start),
                        horizontalArrangement = Arrangement.Start
                    ) {
                        Column(
                            Modifier.fillMaxWidth().fontSize(18.px),
                            horizontalAlignment = Alignment.CenterHorizontally
                        ) {
                            // Login Form
                            if (!isLoggedIn) {
                                Div(
                                    Modifier
                                        .width(if (isMobile) 95.percent else 70.percent)
                                        .margin(25.px)
                                        .textAlign(TextAlign.Center).fontWeight(FontWeight.Bold)
                                        .fontSize(20.px)
                                        .toAttrs()
                                ) {
                                    Text("Welcome to Book Brief!")
                                }
                                Div(
                                    Modifier.margin(left = 40.px, right = 40.px)
                                        .textAlign(TextAlign.Center).toAttrs()
                                ) {
                                    Text("Get insights from the greatest minds. In BookBrief you get summaries of the most influential " +
                                            "books ever written. Focus in the key takeaways from the books that shaped the world, and save time for what really matters.")
                                }
                                Column {
                                    if (!resetCode.isNullOrBlank() && !email.isNullOrBlank()) {
                                        Box(CardStyle.toModifier()) {
                                            ResetPassForm(email = email, resetCode = resetCode,
                                                onSetNewPasswordSuccess = { email: String, resetCode: String, userId: String ->
                                                    console.log("Reset password success for email: $email, resetCode: $resetCode")
                                                    isLoggedIn = true
                                                    username = email
                                                    context.router.navigateTo("/")
                                                    window.localStorage.setItem("username", email)
                                                    window.localStorage.setItem("deviceId", email)
                                                    window.localStorage.setItem("userId", userId)
                                                }
                                            )
                                        }
                                    } else {
//                                    if(SiteConfig.enterAsGuest) {
//                                        Box(CardStyle.toModifier().align(Alignment.CenterHorizontally)
//                                            .margin(top=20.px, bottom = 0.px)
//                                            .padding(top=20.px, bottom = 0.px)) {
//                                            Label() {
//                                                Button (attrs = Modifier.toAttrs() {
//                                                    onClick {
//                                                        isLoggedIn = true
//                                                        username = "guest"
//                                                        context.router.navigateTo("/")
//                                                        window.localStorage.setItem("username", username)
//                                                        window.localStorage.setItem("deviceId", username) }
//                                                 }
//                                                )
//                                                { Text("Enter as Guest") }
//                                            }
//                                        }
//                                    }
                                        Div(
                                            Modifier.height(5.vh)
                                                .align(Alignment.CenterHorizontally)
                                                //width(100.percent).height(86.vh).borderRadius(0.px)
                                                //.margin(top = 0.px)
                                                .attr("id", "g_id_onload")
                                                .attr("data-auto_prompt", "false")
                                                .attr("data-callback", "handleCredentialResponse")
                                                .attr(
                                                    "data-client_id",
                                                    "106656672549-jhg3ge7n5a1f54ahik3no2blq17ubj6d.apps.googleusercontent.com"
                                                )
                                                .textAlign(TextAlign.Center).toAttrs()
                                        )
                                        Div(
                                            Modifier
                                                //width(100.percent).height(86.vh).borderRadius(0.px)
                                                .attr("class", "g_id_signin").toAttrs()
                                        )
                                        LaunchedEffect(Unit) {
                                            if (!isLoggedIn) {
                                                console.log("not logged in")
                                                val reloaded =
                                                    window.sessionStorage.getItem("reloadedOnce")
                                                if (reloaded != "true") {
                                                    window.sessionStorage.setItem(
                                                        "reloadedOnce",
                                                        "true"
                                                    )
                                                    window.location.reload()
                                                } else {
                                                    window.sessionStorage.removeItem("reloadedOnce")
                                                }
                                            }
                                        }
//                                    Box(CardStyle.toModifier().align(Alignment.CenterHorizontally).margin(top = 16.px)) {
//                                        Link("#", variant = null) {
//                                            Text("Login with user and password")
//                                        }
//                                    }
                                        if (SiteConfig.enterAsGuest) {
                                            Button(attrs = Modifier.toAttrs() {
                                                onClick {
                                                    isLoggedIn = true
                                                    username = "guest"
                                                    context.router.navigateTo("/")
                                                    window.localStorage.setItem(
                                                        "username",
                                                        username
                                                    )
                                                    window.localStorage.setItem(
                                                        "deviceId",
                                                        username
                                                    )
                                                }
                                            }
                                            )
                                            { Text("Enter as Guest") }
                                        }
                                        Button(
                                            attrs = Modifier.margin(top = 8.px).toAttrs {
                                                onClick { showCredentialsLoginPanel = true }
                                            }
                                        ) { Text("Login with user and password") }

                                        if (showCredentialsLoginPanel) {
                                            Box(CardStyle.toModifier()) {
                                                LoginForm(
                                                    onLoginSuccess = { a: String, b: String, c: String ->
                                                        isLoggedIn = true
                                                        username = a
                                                        context.router.navigateTo("/")
                                                        window.localStorage.setItem("username", a)
                                                        window.localStorage.setItem("deviceId", b)
                                                        window.localStorage.setItem("userId", c)
                                                    }
                                                )
                                            }
                                            Box(CardStyle.toModifier()) {
                                                RegisterForm(
                                                    onRegisterSuccess = {
                                                    }
                                                )
                                            }
                                        }
                                    }
                                }
                            }
                            Column {
                                if (isLoggedIn) {
                                    HomePage2Test(
                                        true,
                                        isMobile,
                                        onLogout = {
                                            isLoggedIn = false
                                        }) // pass isMobile so child can adapt sizes
                                }

                            }
                        }
                    }
                }

                // Side Content
                if (isLoggedIn) {
                    if (!isMobile) {
                        // Desktop: reserve fixed side width so it doesn't overlap main content
                        Column(
                            Modifier
                                .styleModifier {
                                    // fixed-width side column, will wrap below the main column if space is constrained
                                    property("flex", "0 0 280px")
                                    property("box-sizing", "border-box")
                                }
                                .padding(8.px)
                                .zIndex(2)
                        ) {
                            //SideContent()
                        }
                    } else {
                        // Mobile: show as overlay/modal
                        Box(
                            Modifier
                                .position(Position.Fixed)
                                .top(0.px)
                                .left(0.px)
                                .width(90.vw)
                                .height(80.vh)
                                .backgroundColor(rgba(0, 0, 0, 0.5))
                                .zIndex(if (showSideContent) 101 else -1) // Show only when `showSideContent` is true
                                .onClick { /*showSideContent = false*/ }
                        ) {
                            Column(
                                Modifier
                                    .backgroundColor(Colors.White)
                                    .padding(2.px)
                                    .margin(top = 0.px, left = 0.px, right = 0.px)
                                    .borderRadius(0.px)
                                    .width(90.vw)
                                    .maxHeight(80.vh)
                                    .position(Position.Relative)
                                    .zIndex(if (showSideContent) 101 else -1)
                                    .onClick { /* prevent modal close on content click */ },
                                horizontalAlignment = Alignment.End
                            ) {

                                //SideContent(onCloseWindow = { showSideContent = false})
                            }
                        }
                    }
                }
            }
        }


    }
}

fun JsInteropPage2(deviceId: String) {

    loadYaireoScript() {
        console.log("yaireo loaded")
    }
    loadMyScripts(onLoaded =  {
        js("setDeviceId")(deviceId)
    })
}

fun loadYaireoScript(onLoaded: () -> Unit = {}) {

    val jqueryScript = window.document.createElement("script") as HTMLScriptElement
    jqueryScript.setAttribute("src", "https://cdn.jsdelivr.net/npm/@yaireo/tagify")
    jqueryScript.setAttribute("src", "scripts/yaireo.js")
    jqueryScript.setAttribute("type", "text/javascript")
    jqueryScript.onload = {
        onLoaded()
    }
    window.document.head?.appendChild(jqueryScript)
    console.log("Yaireo loaded")
}


@Composable
fun HomePage2Test(isLoggedIn: Boolean, isMobile: Boolean, onLogout: () -> Unit) {

    // Use `isMobile` to adapt image sizes, card base width and font sizes for small screens.

    LaunchedEffect(Unit) {
        JsInteropPage2(deviceId)
    }

    // STATE: manage books and selection
    var books by remember { mutableStateOf<List<Book>>(emptyList()) }
    var gotBooks by remember { mutableStateOf(false) }
    var selectedBook by remember { mutableStateOf<Book?>(null) }
    var isLoading by remember { mutableStateOf(false) }
    var refreshKey by remember { mutableStateOf(0) }

    // Fetch books when the component mounts or when refreshKey changes
    LaunchedEffect(refreshKey) {
        gotBooks = false
        isLoading = true
        try {
//            val apiUrl = apiEndpoint.trimEnd('/') + "/api/get-books"
            val apiUrl = "/api/get-books"
            val resp = window.fetch(apiUrl).await()
            if (resp.ok) {
                val txt = resp.text().await()
                books = Json.decodeFromString<List<Book>>(txt)
            } else {
                console.error("Failed to fetch books: ${resp.status}")
                books = emptyList()
            }
        } catch (e: Throwable) {
            console.error("Error fetching books:", e)
            books = emptyList()
        } finally {
            gotBooks = true
            isLoading = false
        }
    }

    Column(
        modifier = MainContainer.toModifier()
            .fillMaxWidth()
            .margin(0.px) // do not force height here; let content determine it
    ) {
        val username = window.localStorage.getItem("username") ?: ""
        Box(
            Modifier
                .fillMaxWidth()
                .padding(16.px)
                .backgroundColor(rgb(208, 209, 210))
                .borderRadius(8.px)
                .padding(16.px)
        ) {
            Column(modifier = Modifier.fillMaxWidth(), horizontalAlignment = Alignment.CenterHorizontally) {
                if (!gotBooks) {
                    Text("Loading books...")
                    Image(src = logo, alt = "Loading", modifier = Modifier.width(50.vh).height(50.vh))
                    return@Column
                }

                if (books.isEmpty()) {
                    Text("No books available.")
                    com.varabyte.kobweb.silk.components.forms.Button(
                        onClick = { refreshKey++ },
                        enabled = !isLoading,
                        modifier = Modifier.margin(top = 16.px).backgroundColor(rgb(220, 53, 69)).color(Colors.White)
                    ) { Text(if (isLoading) "..." else "Retry") }
                    return@Column
                }

                // Gallery: responsive grid using the whole area.
                // Each item keeps image aspect ratio (object-fit: contain) and shows title + author underneath.
                // Keep gallery height-free so it grows naturally (footer stays after it)
                Row(
                    modifier = Modifier
                        .fillMaxWidth()
                        .gap(2.px)
                        .padding(8.px)
                        .margin(bottom = 12.px),
                    horizontalArrangement = Arrangement.Start
                ) {
                    // Wrap rows if too many items - use simple flex-wrap via styleModifier
                    Column(modifier = Modifier.fillMaxWidth()) {
                        Row(
                            modifier = Modifier.fillMaxWidth()
                                .styleModifier {
                                    property("display", "flex")
                                    property("flex-wrap", "wrap")
                                    property("justify-content", "flex-start")
                                    property("gap", "12px")
                                }
                        ) {
                            books.forEach { book ->
                                Column(
                                    modifier = Modifier
                                        .styleModifier {
                                            // Reduce base width on small screens so images/text are smaller
                                            property("flex", if (isMobile) "0 0 120px" else "0 0 160px")
                                            property("box-sizing", "border-box")
                                        }
                                        .margin(2.px)
                                        .onClick { selectedBook = book }
                                        .cursor(com.varabyte.kobweb.compose.css.Cursor.Pointer),
                                    horizontalAlignment = Alignment.CenterHorizontally
                                ) {
                                    Image(
                                        src = book.coverUrl.ifBlank { logo },
                                        alt = book.title,
                                        modifier = Modifier
                                            .width(100.percent)
                                            .styleModifier {
                                                property("height", "auto")
                                                // smaller max height on mobile
                                                property("max-height", if (isMobile) "22vh" else "34vh")
                                                property("object-fit", "contain")
                                                property("display", "block")
                                                property("margin", "0 auto")
                                            }
                                            .borderRadius(6.px)
                                            .boxShadow(offsetX = 0.px, offsetY = 2.px, blurRadius = 6.px, color = rgba(0,0,0,0.12))
                                    )

                                    Spacer()

                                    org.jetbrains.compose.web.dom.Div(
                                        attrs = Modifier.styleModifier {
                                            property("font-weight", "700") // bold title
                                            property("text-align", "center") // center title horizontally
                                            property("font-size", if (isMobile) "10px" else "14px") // smaller on mobile
                                        }.toAttrs()
                                    ) {
                                        org.jetbrains.compose.web.dom.Span { Text(book.title) }
                                        org.jetbrains.compose.web.dom.Br {}
                                    }
                                    org.jetbrains.compose.web.dom.Span(
                                        attrs = Modifier.styleModifier {
                                            property("text-align", "center")
                                            property("font-size", if (isMobile) "10px" else "12px")
                                        }.toAttrs()
                                    ) { Text(book.author) }
                                }
                            }
                        }
                    }
                }

                // Selected book details: overlay/modal shown in front of gallery
                selectedBook?.let { b ->
                    // Dimmed backdrop; clicking it closes the modal
                    Box(
                        Modifier
                            .position(Position.Fixed)
                            .top(0.px)
                            .left(0.px)
                            .width(100.vw)
                            .height(100.vh) // ensure backdrop covers full viewport
                            .backgroundColor(rgba(0,0,0,0.5))
                            .zIndex(1000)
                            .onClick { selectedBook = null } // click outside -> close
                    ) {
                        // Centered details card. consume clicks so outer click doesn't fire.
                        Box(
                            Modifier
                                .position(Position.Fixed)
                                .width(90.vw)
                                .maxWidth(900.px)
                                .margin(top = 6.vh)
                                .left(5.vw)
                                .backgroundColor(rgb(255,255,255))
                                .borderRadius(8.px)
                                .padding(16.px)
                                .zIndex(1001)
                                // limit modal height and allow vertical scrolling for long descriptions
                                .styleModifier {
                                    property("max-height", "calc(100vh - 12vh)")
                                    property("overflow-y", "auto")
                                    property("box-sizing", "border-box")
                                }
                                .onClick { /* consume click; do not close */ }
                        ) {
                            Row(
                                modifier = Modifier.fillMaxWidth().gap(12.px),
                                horizontalArrangement = Arrangement.Start
                            ) {
                                // Large cover on the left
                                Image(
                                    src = b.coverUrl.ifBlank { logo },
                                    alt = b.title,
                                    modifier = Modifier
                                        .width(35.percent)
                                        .styleModifier {
                                            property("height", "auto")
                                            property("max-height", "60vh")
                                            property("object-fit", "contain")
                                            property("display", "block")
                                        }
                                        .borderRadius(6.px)
                                )

                                Column(modifier = Modifier.fillMaxWidth().padding(8.px)) {
                                    // center modal title using shared TitleStyle but scale on mobile
                                    org.jetbrains.compose.web.dom.H2(
                                        attrs = TitleStyle.toModifier()
                                            .styleModifier { property("font-size", if (isMobile) "1.4rem" else "3rem") }
                                            .toAttrs()
                                    ) { Text(b.title) }
                                    org.jetbrains.compose.web.dom.Div { Text("Author: ${b.author}") }
                                    org.jetbrains.compose.web.dom.Div {
                                        Text("First published: ${b.firstPublishedYear ?: "Unknown"} • Category: ${b.category}")
                                    }
                                    Spacer()
                                    // Make the description wrap and scroll inside the modal if long
                                    org.jetbrains.compose.web.dom.Div(
                                        attrs = Modifier
                                            .styleModifier {
                                                property("white-space", "pre-wrap")
                                                property("overflow-y", "auto")
                                                property("max-height", "45vh")
                                                property("font-size", if (isMobile) "0.6rem" else "1.0rem")
                                            }
                                            .toAttrs()
                                    ) {
                                        Text(b.summary)
                                    }

                                    Spacer()
                                    com.varabyte.kobweb.silk.components.forms.Button(
                                        onClick = { selectedBook = null },
                                        modifier = Modifier.margin(top = 12.px).backgroundColor(rgb(100,100,100)).color(Colors.White)
                                    ) {
                                        Text("Close")
                                    }
                                }
                            }
                        }
                    }

                }

            }
        }

    }
    // Footer is rendered after the content so it will be the last thing on the page
    SiteFooter()

}
